import { type Column, ilike, type SQL } from "drizzle-orm";

// "Open" must include Reopen/Reopened — legacy T-SQL uses `LIKE '%OPEN%'` so reopened
// claims (still active work) are counted alongside fresh Open claims.
export function isOpenStatus(status: string | null | undefined): boolean {
  if (!status) return false;
  return /open/i.test(status);
}

export function openStatusFilter(column: Column): SQL {
  return ilike(column, "%open%");
}
